import { render, staticRenderFns } from "./block-configurator.vue?vue&type=template&id=f1a268ea"
import script from "./block-configurator.vue?vue&type=script&lang=ts"
export * from "./block-configurator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports